import { ApiError } from '@citibox-panel/api-client';

export type SaveFailure =
  | { kind: 'denied' }
  | { kind: 'conflict' }
  | { kind: 'message'; text: string };

// TODO: i18n
const GENERIC = 'No se han podido guardar los cambios. Vuelve a intentarlo.';
// A Map, not an object literal: a code such as «constructor» must miss, never resolve to a
// built-in of Object.prototype.
const COPY: ReadonlyMap<string, string> = new Map([
  ['assignment_self_edit', 'No puedes modificar tu propia asignación.'],
  ['assignment_systems_protected', 'Las personas de Sistemas se gestionan desde backend.'],
  ['assignment_permission_not_assignable', 'Ese permiso no se puede asignar desde aquí.'],
  ['assignment_email_invalid', 'Escribe un email @citibox.com.'],
]);

// The one 403 of this resource: the caller no longer manages access. Any other 403 is an ordinary
// failure shown in the dialog.
export function isAccessManageDenied(error: unknown): boolean {
  return (
    error instanceof ApiError && error.status === 403 && error.code === 'access_manage_required'
  );
}

// Only the code decides the text. The server's message and detail are never read, so they cannot
// end up rendered.
export function classifySaveError(error: unknown): SaveFailure {
  if (isAccessManageDenied(error)) return { kind: 'denied' };
  if (!(error instanceof ApiError)) return { kind: 'message', text: GENERIC };
  if (error.status === 409) return { kind: 'conflict' };
  return { kind: 'message', text: COPY.get(error.code) ?? GENERIC };
}
